import { Text } from '@aia/ui/atoms';

export function ListItem({ children }: { children?: React.ReactNode }) {
  return (
    <li className="list-item text-gray-300 mb-1.5">
      <Text className="text-foreground">{children}</Text>
    </li>
  );
}
